import React from 'react';
import PropTypes from 'prop-types';

import { Box, Dataflow02Icon, FilterFunnel02Icon, SwitchHorizontal01Icon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

export default function PipelineConfigCell({ hasPipelineFilter, hasPipelineTransform, hasPipelineEventSplit }) {
  const configIndicators = [
    {
      configured: hasPipelineFilter,
      dataTestId: 'pipelineFilterConfigIndicator',
      Icon: FilterFunnel02Icon,
      label: 'Pipeline Filter',
    },
    {
      configured: hasPipelineTransform,
      dataTestId: 'pipelineTransformConfigIndicator',
      Icon: SwitchHorizontal01Icon,
      label: 'Pipeline Transform',
    },
    {
      configured: hasPipelineEventSplit,
      dataTestId: 'pipelineEventSplitConfigIndicator',
      Icon: Dataflow02Icon,
      label: 'Pipeline Event Split',
    },
  ];

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {configIndicators.map(({ configured, dataTestId, Icon, label }) => {
        const title = configured ? `${label} configured` : `No ${label} configured`;

        return (
          <WithTooltip key={label} show title={title}>
            <Icon
              aria-label={title}
              color={configured ? 'success' : 'disabled'}
              data-test-id={dataTestId}
              fontSize="small"
            />
          </WithTooltip>
        );
      })}
    </Box>
  );
}

PipelineConfigCell.propTypes = {
  hasPipelineFilter: PropTypes.bool.isRequired,
  hasPipelineTransform: PropTypes.bool.isRequired,
  hasPipelineEventSplit: PropTypes.bool.isRequired,
};
